export default __webpack_public_path__ + "static/media/BlowBlow.0af86eaf.png";